import { Deserializable } from '../protocols/deserializable';
import { DateUtils } from '../../utils/date-utils';
import { Mentionable } from './mentionable';

export class BaseComment implements Deserializable {
  public id!: string;
  public authorId!: string;
  public comment!: string;
  public createdDate!: string;
  public readDate!: string | null;

  // Set on comment subtypes (e.g. SubmissionComment) to indicate the comment is shared
  // with the member. Drives the "Visible to Member" tag in the comment list.
  public visibleToMember?: boolean;

  // Not from API
  public formattedDate!: string;
  public author!: Mentionable;

  onDeserialize(): void {
    if (!!this.createdDate) {
      this.formattedDate = DateUtils.formatDateStringToCurrentDateTime(this.createdDate);
    }
  }

  public getFormattedComment<T>(users: Mentionable[]): T {
    this.comment = this.comment.replace(/\n/g, '<br>');
    return {
      ...this,
      comment: this.comment.replace(/\{\{(\d+)\}\}/g, (_, id) => {
        const replacement = users.find(item => item.id === +id);
        return replacement ? `<span class="tagged-user">@${replacement.fullName}</span>` : '';
      })
    } as T;
  }
}
